import { CONFIGURATION } from "@revolt/common";

/**
 * Адрес страницы Knot, которая выдаёт одноразовый код и возвращает человека
 * обратно в чат уже залогиненным.
 *
 * Собирается в одном месте намеренно: адрес Knot задаётся переменной окружения
 * контейнера (`VITE_KNOT_URL`), и разъехавшиеся варианты этой ссылки означали бы,
 * что часть кнопок «Войти через Knot» ведёт в никуда.
 */
export function knotLoginUrl(returnPath: string = "/app"): string {
  const base = CONFIGURATION.KNOT_URL;
  if (!base) return "/login/auth";

  const url = new URL(`${base}/stoat/login`);
  // Возвращаться человек должен туда, куда шёл: на канал, а не на главную.
  // Путь всегда относительный — Knot отвергает абсолютные адреса, иначе ссылка
  // из чата могла бы увести человека на чужой сайт.
  url.searchParams.set("return", returnPath);
  return url.toString();
}

/** Настроен ли вход через Knot на этом сервере. */
export function knotLoginEnabled(): boolean {
  return Boolean(CONFIGURATION.KNOT_URL);
}
